import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TextEditorComponent } from '../../text-editor/text-editor.component';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';

@Component({
  selector: 'app-modale-content',
  templateUrl: './modale-content.component.html',
  styleUrls: ['./modale-content.component.css']
})
export class ModaleContentComponent implements OnInit {

  value: string; // Nom de l'élément
  ref: string; // Référence de l'élément
  content: any; // HTML venant du textEditor
  contentType: 'TEXT' | 'VIDEO' | 'DOCUMENT';
  status: any;
  videoURL: string = '';
  file: any;

  @ViewChild('appTextEditor', { static: false })
  appTextEditor: TextEditorComponent;

  get isText() {
    return this.contentType === 'TEXT';
  }

  get isVideo() {
    return this.contentType === 'VIDEO';
  }

  get isDocument() {
    return this.contentType === 'DOCUMENT';
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<ModaleContentComponent>, private httpClientService: HttpclientService) { }

  ngOnInit(): void {
    this.content = this.data?.content ? this.data?.content : '';
    this.value = this.data?.value ? this.data?.value : '';
    this.ref = this.data?.ref ? this.data?.ref : '';
    this.contentType = this.data?.type ? this.data?.type : 'TEXT';
    if (this.isVideo) {
      this.videoURL = this.content;
    }  
    
    if (this.isDocument) {
      this.file = this.content;
    }
  }

  close() {
    this.dialogRef.close();
  }

  validate() {
    if (this.isVideo) {
      this.content = this.videoURL;
    }

    if (this.isDocument) {
      this.content = this.file;
    }    

    this.dialogRef.close({ blocValue: this.value, contentType: this.contentType, content: this.isText ? this.appTextEditor.getContent() : this.content, blocRef: this.ref });
  }

  loadDocument(event: any) {
    let selectedFile = event.target.files[0];
    if (!selectedFile) {
      return;
    }
    this.uploadFile(selectedFile);
  }


  uploadFile(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    this.httpClientService
      .postWithHeader(formData, {}, '/resource-files')
      .subscribe({
        next: (resourceFile) => {
          this.file = resourceFile;
        },
        error: (error) => {
          console.error('Error uploading image:', error);
        },
      });
  }
  

}
